import React from 'react';
import { Link, withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import NewWindow from 'react-new-window'
import logo from '../../assets/img/sonic-globe.png';
import ForgotPasswordDialog from './ForgotPasswordDialog'
import BobDialog from './BobDialog'

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  root: {
    flexGrow: 1,
  },
  form: {
    height: 240,
    marginTop: theme.spacing.unit * 20
  },
  logo: {
    height: 65,
  },
  paper: {
    padding: theme.spacing.unit * 2,
  //  height: '100%',
    color: theme.palette.text.secondary,
  },
  control: {
    padding: theme.spacing.unit * 2,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 250,
  },
  menu: {
    width: 200,
  },
  button: {
    marginTop: theme.spacing.unit * 5,
    marginBottom: theme.spacing.unit
  },
  signUpButton: {
    marginBottom: theme.spacing.unit
  },
});


@inject("authStore", "commonStore")
@withRouter
@observer

class Login extends React.Component {

  state = {
    //showForgotPasswordDialog: false
    showBob: false,
    showBobDialog: false
  };

  
  componentWillUnmount() {
    this.props.authStore.reset();
  }

  handleEmailChange = e => this.props.authStore.setEmail(e.target.value);
  handlePasswordChange = e => this.props.authStore.setPassword(e.target.value);
  handleSubmitForm = e => {
    const { authStore } = this.props;
    const { values } = authStore;
    const { email, password } = values

    if(email === '' || email === null || email === undefined){
      return
    }

    if(password === '' || password === null || password === undefined){
      return
    }

    e.preventDefault();
    this.props.authStore.login().then(result => {
      console.log('result')
      console.log(result)

      if(result === '' || result === null || result === undefined){
        return
      }else if (result){
        this.props.history.replace("/");
      }else{
        this.props.history.replace("/confirmpassword");
      }
    })
    .catch(err => {
        //show error alert
    })
  };
  closeForgotPasswordDialog = () => {
    this.props.authStore.showForgotPasswordDialog(false)
    //this.setState({showForgotPasswordDialog: false})
  }

  forgotPassword = () => {
    this.props.authStore.showForgotPasswordDialog(true)
   // this.setState({showForgotPasswordDialog: true})
  }
  signUp = () => {
    this.setState({showBobDialog: true})
  }
  newWindowUnload = () => {
    this.setState({showBob: false})
  }
  /*handleSubmitForgotPassword = e => {
    const { values } = this.props.authStore;
    const { email } = values 
    if(!email){
      //warn no email
      return 
    }
    
    e.preventDefault();
    this.props.authStore.forgotPW().then(cognitoUser => {
     
      console.log(cognitoUser)
      const verificationCode = prompt('Please input verification code ' ,'');
      const newPassword = prompt('Enter new password ' ,'');

      cognitoUser.confirmPassword(verificationCode, newPassword, this);

       // if(result){
        //    console.log(result)
        //    result.confirmPassword(this.codeInput(), this.newPWInput(), this)
       // }else{
           // this.props.history.replace("/");
       // }
       
    })
  };*/

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleBobDialogClose = (cancel) => {
    if(cancel){
      this.setState({showBobDialog: false})
    }else{
      console.log('should show bob')
      this.setState({showBob: true, showBobDialog: false})
    }


  }
  render() {
    const { showBob, showBobDialog } = this.state
    const { classes, authStore, commonStore } = this.props;
    const { values, inProgress, forgotPasswordDialogVisible } = authStore;
    const { signInError } = commonStore

    console.log(signInError.message)


    return (
      <div>
      <Grid container className={classes.root}>
      <Grid
      container
      className={classes.form}
      alignItems={'center'}
      direction={'row'}
      justify={'center'}
    >
      <Paper className={classes.paper}>
      <h2 style={{textAlign:'center'}}>Welcome</h2>
      <Typography color="error">{signInError.message}</Typography>
      <form className={classes.container} onSubmit={this.handleSubmitForm} noValidate autoComplete="off">     
      <Grid
      container
      alignItems={'center'}
      direction={'column'}
      justify={'center'}
    >
      <TextField
        required
        id="email"
        label="Email"
        className={classes.textField}
        value={values.email}
        onChange={this.handleEmailChange}
        margin="normal"
      />
  
        <TextField
        id="password-input"
        label="Password"
        className={classes.textField}
        type="password"
        autoComplete="current-password"
        margin="normal"
        onChange={this.handlePasswordChange}
      />
      <Button variant="contained" type="submit" color="primary" className={classes.button}>
        Log In
      </Button>
      <Button className={classes.button} onClick={this.forgotPassword}> Forgot Password? </Button>
      <Typography variant="Caption"> For Assistance Call (888) 448-7531 </Typography>
      {/*<Button className={classes.signUpButton} onClick={this.signUp}> Sign Up! </Button>*/}
      </Grid>
    </form>
      </Paper>
      </Grid>
      </Grid>
     <ForgotPasswordDialog open={forgotPasswordDialogVisible} email={values.email} updateEmail={this.handleEmailChange} submit={this.handleSubmitForgotPassword} close={this.closeForgotPasswordDialog}/> 

     { showBob ? <NewWindow
      url={'https://console.dialogflow.com/api-client/demo/embedded/9788afd6-1ab1-4ca4-a9de-919260f7bbe8'} 
      copyStyles={false}
      onUnload={this.newWindowUnload}
      /> : null }

      <BobDialog open={showBobDialog} close={this.handleBobDialogClose}/>
       
     </div>
            
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Login);



/*import { Link, withRouter } from "react-router-dom";
import BasicPage from "../lib/BasicPage";
import React from "react";
import { inject, observer } from "mobx-react";
import { FormGroup, FormControl, Button } from "react-bootstrap";

@inject("authStore")
@withRouter
@observer
export default class Login extends React.Component {
  componentWillUnmount() {
    this.props.authStore.reset();
  }

  handleEmailChange = e => this.props.authStore.setEmail(e.target.value);
  handlePasswordChange = e => this.props.authStore.setPassword(e.target.value);
  handleSubmitForm = e => {
    e.preventDefault();
    this.props.authStore.login().then(result => {
      if (result){
        this.props.history.replace("/");
      }else{
        this.props.history.replace("/confirmpassword");
      }
    })
    .catch(err => {
        //show error alert
    })
  };

  render() {
    const { values, inProgress } = this.props.authStore;

    return (
      <BasicPage title="Login">
       <p>
          <Link to="forgotpassword">Forgot Password?</Link>
       </p>

        <form onSubmit={this.handleSubmitForm}>
          <FormGroup>
            <FormControl
              type="email"
              placeholder="Email"
              value={values.email}
              onChange={this.handleEmailChange}
            />
          </FormGroup>

          <FormGroup>
            <FormControl
              type="password"
              placeholder="Password"
              onChange={this.handlePasswordChange}
            />
          </FormGroup>

          <Button
            bsSize="large"
            bsStyle="primary"
            type="submit"
            disabled={inProgress}
          >
            Login
          </Button>
        </form>
      </BasicPage>
    );
  }
}
*/


// WEBPACK FOOTER //
// ./src/components/Account/Login.js